(function (app) {

    app.run([
        "AuthService", "$state", "$timeout", "$transitions", function (AuthService, $state, $timeout, $transitions) {

            //TODO: change this to mean everything except the login/logout pages
            //currently everything falls under Home. but may not always be the case
            //TODO: include redirect info, like where the user was going so that after login they may continue 
            //TODO: or..instead of redirecting to login, have a modal come up and ask for auth?
            //that seems more like a popup warning on session timeout rather than waiting for the user
            //to change states so maybe this is fine
            $transitions.onBefore({ to: "Home.**" },
                function (transition) {
                    var redirect = $state.href(transition._targetState._definition, transition._targetState._params, transition._targetState._options);
                    if (redirect === "#") redirect = null;
                    return AuthService.isAuthenticated().then(function (isAuth) {
                        if (!isAuth) { return transition.router.stateService.target("Login", { redirect: redirect }); }
                        else if (!transition._targetState._definition.name.includes("MarketingTracker")) {
                            $timeout(
                                function () {
                                    //INFO: Use $timeout vs setTimeout in AngularJS
                                    $(".new-portal-preloader .preloader").addClass("active");
                                })
                                .then(function () {
                                    return $timeout(function () {
                                        console.log("loaded");
                                        window.location = window.location.protocol + "//" + window.location.host + '/Portal/Dashboard';
                                    }, 2000);
                                })
                                //.then(function () {
                                //    return $timeout(function () {
                                //        $("#preloader-section .preloader").addClass("exit");
                                //    }, 2500);
                                //})
                                //.then(function () {
                                //    return $timeout(function () {
                                //        //$("#preloader-section").remove();
                                //        $("#preloader-section .preloader")
                                //            .removeClass("active")
                                //            .removeClass("exit");
                                //    }, 1000);
                                //})
                                ;
                        }
                    });
                });

            $transitions.onSuccess({},
                function (transition) {
                    var mtLoader = false,
                        fromState = transition.from().name,
                        toState = transition.to().name;
                    var load = function () {
                        $timeout(function () {
                            $(".marketing-tracker-preloader .preloader").addClass("active");
                        })
                            .then(function () {
                                return $timeout(function () {
                                    $("#preloader-section .preloader").addClass("exit");
                                }, 3000);
                            })
                            .then(function () {
                                return $timeout(function () {
                                    //$("#preloader-section").remove();
                                    $("#preloader-section .preloader")
                                        .removeClass("active")
                                        .removeClass("exit");
                                }, 1000);
                            });
                    }
                    //console.log('includes mtNew?', toState.includes('Home.Tools.MarketingTrackerNew'));
                    //console.log('from includes mtNew?', fromState.includes('Home.Tools.MarketingTrackerNew'));
                    //console.log('from is !!?', !!fromState);

                    if (toState.includes('Home.Tools.MarketingTrackerNew')) {
                        return $timeout(function () {
                            mtLoader = !!fromState
                                ? fromState.includes('Home.Tools.MarketingTrackerNew')
                                    ? false
                                    : true
                                : true;
                        })
                            .then(function () {
                                if (mtLoader) { load(); }
                            });
                    }
                });

            $transitions.onBefore({ to: "Login" },
                function (transition) {
                    return AuthService.isAuthenticated().then(function (isAuth) { if (isAuth) return transition.router.stateService.target("Home"); });
                });

            $transitions.onBefore({ to: "Logout" },
                function (transition) {
                    return AuthService.isAuthenticated().then(function (isAuth) { if (!isAuth) return transition.router.stateService.target("Login"); });
                });

            $transitions.onBefore({ to: "Register" },
                function (transition) {
                    return AuthService.isAuthenticated().then(function (isAuth) { if (isAuth) return transition.router.stateService.target("Home"); });
                });

            $transitions.onBefore({ to: "Invalid" },
                function (transition) {
                    return AuthService.isAuthenticated().then(function (isAuth) { if (isAuth) return transition.router.stateService.target("Home"); });
                });
        }
    ]);

    app.run([
        "permissionService", "$transitions", function (permissionService, $transitions) {
            $transitions.onEnter({},
                function (transition) {
                    var permissions = transition.$to().requiredPermissions;
                    if (!permissions) return undefined;
                    if (permissionService.hasAllPermissions(permissions)) return undefined;
                    return transition.router.stateService.target("Home");
                },
                { priority: 1 });
        }
    ]);

    app.run([
        "permissionService", "$transitions", function (permissionService, $transitions) {
            $transitions.onEnter({},
                function (transition) {
                    var permissions = transition.$to().requiredOnePermission;
                    if (!permissions) return undefined;
                    if (permissionService.hasOnePermission(permissions)) return undefined;
                    return transition.router.stateService.target("Home");
                },
                { priority: 1 });
        }
    ]);

    //app.run(["$trace", function($trace) { $trace.enable("TRANSITION"); }]);

})(window.app);